export const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === "object" && value !== null && !Array.isArray(value);

export const hasKey = <K extends string>(
    value: unknown,
    key: K
): value is Record<string, unknown> & Record<K, unknown> =>
    isRecord(value) && key in value;

export const getErrorResponseData = (err: unknown): { data: unknown } | undefined => {
    if (hasKey(err, "response") && hasKey(err.response, "data")) {
        return err.response.data as { data: unknown };
    }
    return undefined;
};

export const getErrorStatus = (err: unknown): number | undefined => {
    if (
        hasKey(err, "response") &&
        hasKey(err.response, "status") &&
        typeof err.response.status === "number"
    ) {
        return err.response.status;
    }
    return undefined;
};

